export const StatusChip = ({ status, value }) => {
  switch (status?.toString()?.toUpperCase()) {
    case "1":
      return <div title={value&&"Success"||"Active"} className="chip chip--success"> {value || "Active"} </div>;
    case "0":
      return <div title={value&&"Failed"||"InActive"} className="chip chip--danger">{value || "InActive"}</div>;
    case "true":
      return <div title={value&&"Success"||"Active"} className="chip chip--success"> {value || "Active"} </div>;
    case "false":
      return <div title={value&&"Failed"||"InActive"}  className="chip chip--danger">{value || "InActive"}</div>;
      case "TRUE":
        return <div title={value&&"Success"||"Active"} className="chip chip--success"> {value || "Active"} </div>;
      case "FALSE":
        return <div title={value&&"Failed"||"InActive"}  className="chip chip--danger">{value || "InActive"}</div>;
    case "Active":
      return <div className="chip chip--success">Active</div>;
    case "InActive":
      return <div className="chip chip--danger">InActive</div>;
    case "EXECUTED":
      return <div className="chip chip--success">Executed</div>;
    case "UPLOADED":
      return <div className="chip chip--warning">Uploaded</div>;
    case "IN PROGRESS":
      return <div className="chip chip--warning">Processing</div>;
    case "FAILED":
      return <div className="chip chip--danger">Failed</div>;
    case "COMPLETED":
      return <div className="chip chip--success">COMPLETED</div>;
    case "PAID":
      return <div className="chip chip--success">Paid</div>;
    case "EXPIRED":
      return <div className="chip chip--disabled">Expired</div>;
    case "PENDING":
      return <div className="chip chip--warning">Pending</div>;
    case "SUCCESS":
      return <div className="chip chip--success">{value || "Success"}</div>;
    default:
      break;
  }
};
